import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams, HttpErrorResponse, HttpResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { GlobalUtilityService } from '@AppCore/services/global-utility.service';
import { APIResponse } from '@AppRoot/shared/models/api-response.interface';


@Injectable({
	providedIn: 'root'
})
export class HttpHelperService {

	constructor(
		private _httpClient: HttpClient,
		private globalUtility: GlobalUtilityService
	) { }

	get(url: string, query: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>; } = {}, requiresAuth = true, header?: { [header: string]: string | string[]; }): Observable<APIResponse> {
		let headers = this._addCustomHeaders(false, requiresAuth, false, header);
		return this._httpClient.get<APIResponse>(url, { headers, params: query })
			.pipe(
				catchError(this.errorHandler.bind(this))
			);
	}

	post(url: string, body: any | null, requiresAuth = true, isUrlEncoded = false, formData = false, header?: { [header: string]: string | string[]; }): Observable<APIResponse> {
		let headers = this._addCustomHeaders(isUrlEncoded, requiresAuth, formData, header);
		if(body instanceof FormData){
			headers = headers.delete('Content-Type');
		}
		return this._httpClient.post<APIResponse>(url, body, { headers })
			.pipe(
				catchError(this.errorHandler.bind(this))
			);
	}

	put(url: string, body: any | null, requiresAuth = true, isUrlEncoded = false, formData = false, header?: { [header: string]: string | string[]; }): Observable<APIResponse> {
		let headers = this._addCustomHeaders(isUrlEncoded, requiresAuth, formData, header);
		return this._httpClient.put<APIResponse>(url, body, { headers })
			.pipe(
				catchError(this.errorHandler.bind(this))
			);
	}

	delete(url: string, query: Object, requiresAuth = true, isUrlEncoded = false, header?: { [header: string]: string | string[]; }): Observable<APIResponse> {
		let headers = this._addCustomHeaders(isUrlEncoded, requiresAuth, false, header);
		let searchParams = this.addSearchParams(query);
		return this._httpClient.delete<APIResponse>(url, { headers, params: searchParams })
			.pipe(
				catchError(this.errorHandler.bind(this))
			);
	}

	private addSearchParams(customParam: any) {
		let search: HttpParams = new HttpParams();
		for (const key in customParam) search = search.append(key, customParam[key]);
		return search;
	}

	private _addCustomHeaders(isUrlEncoded = false, requiresAuth = false, formData = false, customHeaders?: { [header: string]: string | string[]; }): HttpHeaders {
		let headers: HttpHeaders;

		if (isUrlEncoded) {
			headers = new HttpHeaders({
				'Content-Type': 'application/x-www-form-urlencoded'
			});
		}
		else if (formData) {
			headers = new HttpHeaders({
				'Content-Type': 'multipart/form-data',
				'Access-Control-Allow-Origin': '*',
			});
		}
		else {
			headers = new HttpHeaders({
				'Content-Type': 'application/json',
				'Access-Control-Allow-Origin': '*',
			});
		}
		if (requiresAuth) {
			let session = this.globalUtility.getDataFromLocalStorage('token');
			headers = headers.append('key', session);
		}
		if (customHeaders) Object.keys(customHeaders).forEach(key => headers = headers.append(key, customHeaders[key]));
		return headers;
	}

	errorHandler(response: HttpErrorResponse) {
		this.globalUtility.hideSpinner();
		if (response && response.error && response.error.errors && response.error.errors.length) {
			return throwError(() => new Error(response.error.errors.reduce((previousValue: string, currentValue: { message: string }) => previousValue + currentValue.message + ' ', '')));
		} else {
			return throwError(() => new Error(`Some thing went wrong.`));
		}
	}


}
